<template>
	<div id="usre-baseinfor" class="oh">
		<!-- 政府端 -->
		<leftnav class="fl" mkcode="E" itemcode="E-GXJSQ"></leftnav>
		<div class="index_left" :style="isCollapse?'margin-left: 0;width:100%':''">
			<govheader :show-video="true" :video-type="5"></govheader>
			<div class="index_left_centerpage whitebox" style="min-height: 95vh;">
				<div class="heightVh95 whitebox container-flex-center">
					<freeUserTips :type="4" :bgtype="0" isShowPageTitle="企业-企业关系计算器"></freeUserTips>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

	export default {
		name: 'relationalCalculator',
		computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
		data() {
			return {
				userdata: {}, 
				pagetype:1,//单个计算为1 批量计算为2
				title: '联系人关系计算器', 
				hascalcu: false, 
				iscalcu: false, 
				tipstext: '',
				conversantlist: [], 
				conversantlistChecked: [], 
				contactlist: [],
				conversantlistTem: [],//临时熟悉列表
				contactlistTem:[],//临时联系列表
				conversantlistCheckedTem: [],//临时选择列表
				showtype: 'chooseconversant',
				chooseconvertext: "",
				saveconvertext: '',
				chooseContact: [],
				chooseconversant: [],
				popbtn: false,
				searchtext: "",
				batchSearchtext:'',//批量搜索文本
				searchlist: [], 
				editbtn: false,
				tipstext1: '',
				// 计算器结果data存值分割线 {relation:[{stockCode:"",title:""}]}
				resultslist: [],
				guideid: "",
				resultdata: {},
				saveresultbtn: true,
			}
		},
		created() {
			this.userdata = this.getuseriformation();
		},
		mounted() {
			// this.calculatorFun()
			
		},
		methods: { 
			//页面切换
			pageToggle(type){
				this.pagetype=type;
				this.iscalcu=false;
				this.tipstext="";
				this.tipstext1="";
				this.resultslist=[];
				this.resultdata={};
				this.hascalcu="";
				if(type == 2){
					this.getEnterpriseList();
				}
				
			},
			getEnterpriseList() {
				this.bus.$emit('loading', true);
				var _this = this;
				var ajaxurl = this.$api.cyl.enterpriseRelation.enterpriseList();
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('用户添加的熟悉联系列表', res.data);
					if (res.data.success) {
						let resdata = res.data.data;
						var sourcedata = resdata.source ? resdata.source : [],sourcedata1=[];
						var targetdata = resdata.target ? resdata.target : [],targetdata1=[];
      for(var i=0;i<sourcedata.length;i++){
							sourcedata1.push({enterpriseRelationId:sourcedata[i].id,ischecked:false,stockCode:sourcedata[i].stockCode,title:sourcedata[i].title,type:sourcedata[i].type})
						}
						for(var i=0;i<targetdata.length;i++){
							targetdata1.push({enterpriseRelationId:targetdata[i].id,hascalcu:false,stockCode:targetdata[i].stockCode,title:targetdata[i].title,type:targetdata[i].type})
						}
						_this.conversantlist=sourcedata1;
						_this.contactlist=targetdata1; 
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {});
			},
			conversantToggle(type) {
				if(type == 'list'){
					this.conversantlistChecked = this.conversantlist.filter(list => {
						return list.ischecked;
					})
				}else if(type == 'tem'){
					this.conversantlistCheckedTem = this.conversantlistTem.filter(list => {
						return list.ischecked;
					})
				} 
				// alert(88888)
			},
			searchenter(e) {
				if (e.keyCode == 13) {
					this.searchcompany();
				}
			},
			closefun() {
				this.popbtn = false;
				this.searchlist = [];
				this.searchtext = '';
				this.chooseContact = [];
				this.chooseconversant = [];
				this.chooseconvertext = '';
				this.batchSearchtext = '';
			},
			//批量搜索企业
			batchSearchCompany() {
				console.log(this.batchSearchtext);
				 // 去除输入内容中的空格
				 this.batchSearchtext = this.batchSearchtext.trim();
				 // 将多行文本框的内容分割成数组
				  var batchSearchtextTem = this.batchSearchtext.split('\n');
				// 将数组中的元素拼接成字符串
				batchSearchtextTem = batchSearchtextTem.join(',');
				console.log('拼接后',batchSearchtextTem);
				var _this=this;
				var ajaxurl=this.$api.cyl.enterpriseRelation.search();
				$.ajax({
				type:"POST",
				url:ajaxurl,
				data:{title:batchSearchtextTem},
				headers:{AuthToken:this.userdata.token },
				success:function(res){ 
					console.log(res); 
					if(res.success){
						console.log(res);
						var dataList = res.list;
						if(dataList.length==0){
							_this.$message({
											type: 'warning',
											message: '没有找到您需要的企业，请输入正确的企业全称',
										});
							return;
						}
						// else{
							var conversantlist = _this.conversantlistTem;
								if(conversantlist.length>0){//当熟悉列表中有企业时，要去判断新添加的企业中是否有重复的，重复则剔除
									console.log('列表中有数据',conversantlist.length,dataList.length)
									for(var i=0;i<conversantlist.length;i++){
										for(var n=0;n<dataList.length;n++){
											console.log(dataList[n].title,conversantlist[i].title);
										if(conversantlist[i].stockCode == dataList[n].stockCode){
											console.log('重复的企业名称',dataList[n].title);
												_this.$notify({
												type: 'warning',
												message:  dataList[n].title+'已存在于熟悉企业列表中',
											});
											
										} 
									}
									} 
									dataList.forEach(list=>{
										_this.conversantlistTem.push(list);
									})
									const uniqueArr = Array.from(new Set(_this.conversantlistTem.map(JSON.stringify))).map(JSON.parse); 
									console.log('去重',uniqueArr);
									_this.conversantlistTem =uniqueArr;
								}else{
										console.log('熟悉列表为空');
										_this.conversantlistTem =dataList;
									}
					_this.popbtn = false;
					_this.batchSearchtext ='';

					} 
					_this.errortext=res.msg; 
				} 
			});
			},
			searchcompany() {
				this.searchtext = $.trim(this.searchtext);
				var _this = this;
				this.bus.$emit('loading', true);
				var ajaxurl = this.$api.cyl.enterprise.list() + '?page=1&type=0&search=1&kw=' + this.searchtext;
				this.$axios.get(ajaxurl, {
					headers: {
						AuthToken: this.userdata.token
					}
				}).then(function(res) {
					console.log('搜索列表', res.data);
					if (res.data.success) {
						_this.searchlist = res.data.list.slice(0, 10);
						_this.searchlist.forEach(list => { 
							list.ischeck = (_this.saveconvertext.indexOf(list.title) > -1 || _this.chooseconvertext.indexOf(list.title) > -1) && _this.showtype == 'chooseconversantSingle';
						})
						_this.tipstext = '没有找到您需要的企业，请输入正确企业名称';
						_this.bus.$emit('loading', false);
					} else {
						
					}
				}).catch(function(error) {});
			},
			addcheck(list) {
				//chooseContact:[],chooseconversant:[],
				if (!list.ischeck) {
					if (this.showtype == 'chooseContact') {
						this.chooseContact = [{
							stockCode: list.stockCode,
							title: list.title
						}];
						this.searchlist.forEach(item => {
							if (item.title == list.title) {
								item.ischeck = true;
							} else {
								item.ischeck = false;
							}
						})
					} else if (this.showtype == 'chooseconversantSingle') {
						if (this.chooseconvertext.indexOf(list.title) < 0) {
							this.chooseconversant.push({
								stockCode: list.stockCode,
								title: list.title,
								ischecked: false,
							});
							this.chooseconvertext = this.chooseconvertext + list.title + ',';
							this.searchlist.forEach(item => {
								if (item.title == list.title) {
									item.ischeck = true;
								}
							})

						}


					}
				}
			},
			//小删除 临时计算列表引用
			delatefun(type, title) {
				this.tipstext1 = "";
				//type 1234  chooseconversant  chooseContact   conversantlist contactlist
				if (type == 1) {
					this.conversantlistTem = this.conversantlistTem.filter(list => {
						return list.title != title;
					})
				} else if (type == 2) {
					this.contactlistTem = this.contactlistTem.filter(list => {
						return list.title != title;
					})
				} else if (type == 3) {
					this.chooseconversantTem = this.chooseconversantTem.filter(list => {
						return list.title != title;
					});
				} else if (type == 4) {
					this.chooseContact = this.chooseContact.filter(list => {
						return list.title != title;
					})
				}
				if (type == 3 || type == 4) {
					this.searchlist.forEach(list => {
						if (list.title == title) {
							list.ischeck = false;
						}
					})
				}
			},
			//搜索公司名字后保存结果 临时列表引用
			savefun() {
				if (this.showtype == 'chooseContact') {
					this.contactlistTem = this.chooseContact;
				} else if (this.showtype == 'chooseconversant' || this.showtype=='chooseconversantSingle') {

					this.conversantlistTem = this.conversantlistTem.concat(this.chooseconversant);
					var dddgs = '';
					for (var i = 0; i < this.conversantlistTem.length; i++) {
						dddgs = dddgs + this.conversantlistTem[i].title + ',';
					}
					this.saveconvertext = dddgs;
				}
				this.closefun();
			},
			//开始计算 stocktype=all 为左边全部  stocktype为stockcode则为单个
			calculatorFun(type,item) {
					this.hascalcu = true;
					this.tipstext1 = "";
				if (this.iscalcu && item.hascalcu) {
					return;
				}
				var _this = this;
				this.iscalcu = true;
				var conversantText = '', 	contactText = '';
				if(type == 'list'){
					for (var i = 0; i < this.conversantlistChecked.length; i++) {
						let dd = i == 0 ? '' : ',';
						conversantText = conversantText + dd + this.conversantlistChecked[i].stockCode;
					};
				}else if(type == 'tem'){
					for (var i = 0; i < this.conversantlistCheckedTem.length; i++) {
						let dd = i == 0 ? '' : ',';
						conversantText = conversantText + dd + this.conversantlistCheckedTem[i].stockCode;
					};
				}
				
				// if (stocktype == 'all') {
				// 	contactText = this.contactlist[0].stockCode;
				// } else {
				// 	contactText = stocktype;
				// }
				contactText = item.stockCode;
				item.hascalcu=true;
				console.log(conversantText, contactText);
				// var testc = '300750,300769', testd = '10639809';
				// console.log(this.$api.cyl.enterpriseRelation.calculate() + '?sourceList=' + conversantText + '&target=' + contactText,)
				this.$axios.get(this.$api.cyl.enterpriseRelation.calculate() + '?sourceList=' + conversantText +
					'&target=' + contactText, {
						headers: {
							AuthToken: this.userdata.token
						}
					}).then(function(res) {
					console.log('计算结果', res.data)
					if (res.data.success) {
						_this.resultslist = res.data.list ? res.data.list :[];
						if (res.data.list.length > 0) {  
							_this.resultdata = res.data.data; 
							_this.saveresultbtn = true;
						} else {
							_this.tipstext1 = '相熟企业和想联系企业暂无中间联系人'
						}
					
						_this.iscalcu = false;
					} else {
						
					}
				}).catch(function(error) {
					// 请求失败处理 console.log(error);
				});
			},
			saveResultdata() {
				var _this = this;
				var ajaxdata = this.resultdata;
				var ajaxurl = this.$api.cyl.enterpriseRelation.save();
				if (_this.saveresultbtn) {
					$.ajax({
						type: "POST",
						url: ajaxurl,
						data: ajaxdata,
						headers: {
							AuthToken: this.userdata.token
						},
						success: function(res) {
							console.log('1123', res);
							if (res.success) {
								_this.$message({
									type: 'success',
									message: '保存成功，可前往我的关系网查看',
								});
								// alert('保存成功，可前往我的关系网查看');
								_this.saveresultbtn = false;
							}
						}
					})
				}
			},
		}
	}
</script>
<style lang="scss">
	.textarea-inp{
		border: 1px solid #eee;
		height: 450px;
		width: 520px;
		padding-left: 20px;
		font-size: 16px;
		line-height: 28px;
		font-weight: 600;
	}
	.relationCa {
		.smcalcuBtn {
			height: 30px;
			margin: 15px 20px;
			line-height: 30px;
			width: 80px;
		}
		 
		 
		 

		.titlebox h5.graybtn {
			width: 100%;
			height: 42px;
			line-height: 42px;
			font-size: 16px;
			font-weight: normal;
		}
	}

	.barLoading {
		width: 22px;
		height: 22px;
		position: relative;
		top: 5px;
		right: 10px;
	}
	.user_tabtitle1{
		 height: 38px;line-height: 38px;margin-bottom: 32px;
		}
	.user_tabtitle1 li{
		 width: calc(50% - 4px);text-align: center;cursor: pointer;  font-size: 16px;text-align: center;	border:1px solid #5E83CC;
		&.current,&:hover{
			background: #5E83CC;color: #fff; 
		}
	}
</style>
